
/**
 * 共通フッタ
 */
export default {
  name: 'Footer'
};
